const state = {
  industryCategories: [],
  industryCategoriesCompanyId: null,
  externalIndustryCategories: [],
  externalIndustryCategoriesCompanyId: null,
  campaignObjectives: []
}

export default state
